import { Box, BoxProps } from '@chakra-ui/react';

interface BleedBackgroundProps extends BoxProps {
  isMainBg?: boolean;
  bgColor?: string;
  bgImage?: string;
  bgSize?: string;
}

export const BleedBackground = ({
  isMainBg = false,
  bgColor,
  bgImage,
  bgSize,
  ...props
}: BleedBackgroundProps) => {
  return (
    <Box
      data-testid="bleed-background"
      w="100dvw"
      top={isMainBg ? '-2rem' : '0'}
      left="50%"
      transform="translate(-50%)"
      zIndex="-1"
      h={isMainBg ? 'calc(100% + 2rem)' : '100%'}
      position="absolute"
      bgColor={bgColor ?? 'transparent'}
      bgImage={bgImage ?? 'none'}
      bgSize={bgSize ?? 'auto'}
      {...props}
    />
  );
};
